import { formatMoney, formatDocumentDate } from '../format.js';
import { html } from '../html.js';
import { t } from '../strings.js';
/** A figure: LTR island, tabular digits, never mirrored (see format.ts). */
export function ltr(text) {
    return html `<span class="ltr">${text}</span>`;
}
export function money(amount, currency) {
    return ltr(formatMoney(amount, currency));
}
export function docDate(iso) {
    return ltr(formatDocumentDate(iso));
}
/** The company block + the document's own title, side by side. */
export function header(company, title, badge) {
    const meta = [company.taxId, company.address, company.phone, company.email].filter((line) => typeof line === 'string' && line.trim() !== '');
    return html `
    <header class="doc-header">
      <div class="doc-company">
        <h1>${company.name}</h1>
        ${meta.map((line) => html `<div class="meta">${line}</div>`)}
      </div>
      <div class="doc-title">
        <h2>${title}</h2>
        ${badge ?? null}
      </div>
    </header>
  `;
}
export function field(label, value) {
    return html `<div class="doc-field"><dt>${label}</dt><dd>${value}</dd></div>`;
}
export function fields(rows) {
    return html `<dl class="doc-fields">${rows}</dl>`;
}
/**
 * NFR-33's / GEN-190's footer: the company name, the print date, and — when
 * the caller knows one — the person who produced the document. The document
 * number is each template's own header business.
 */
export function footer(locale, generatedAt, companyName, generatedBy) {
    return html `
    <footer class="doc-footer">
      <span>${companyName}</span>
      <span>
        ${t('printedOn', locale)} ${docDate(generatedAt)}${generatedBy
        ? html ` — ${t('printedBy', locale)} ${generatedBy}`
        : null}
      </span>
    </footer>
  `;
}
//# sourceMappingURL=parts.js.map